import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PACK_IMAGE } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="bg-carbon" data-id="element-90" data-mp="9igvb8esxojn">
      <div className="mx-auto flex max-w-page flex-col items-center px-3 pb-5 pt-3 text-center sm:px-6 sm:pb-6 sm:pt-4" data-id="element-91" data-mp="4mi47d239sfj">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.25,
        ease: EASE
      }} className="rounded-full bg-coral/20 px-3 py-1 text-[0.62rem] font-extrabold uppercase tracking-[0.18em] text-coral sm:text-xs" data-id="element-92" data-mp="12862k3i3uktp">
          🔥 Método de entrenamiento paso a paso
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: EASE,
        delay: 0.04
      }} className="mt-1.5 max-w-4xl font-display text-[1.75rem] uppercase leading-[0.98] tracking-wide text-cream sm:text-5xl lg:text-[3.6rem]" data-id="element-93" data-mp="3d21uq4bdkwqw">
          El sistema completo para aprender a entrenar{' '}
          <span className="text-coral" data-id="element-94" data-mp="39al8ybyf2k23">
            glúteos, piernas y tren inferior con estrategia
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: EASE,
        delay: 0.08
      }} className="mt-1.5 max-w-2xl text-[0.8rem] font-semibold leading-snug text-beige sm:text-[0.95rem]" data-id="element-95" data-mp="3e84mtar7cuti">
          Aprende a entrenar con técnica, comprende cómo estructurar tus rutinas
          y empieza a progresar con un plan claro — sin perderte entre cientos
          de videos, ejercicios y rutinas diferentes.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: EASE,
        delay: 0.11
      }} className="mt-2 rounded-md bg-coral px-3 py-1 font-display text-[0.8rem] uppercase tracking-wider text-cream sm:text-base" data-id="element-96" data-mp="2hjyn92950sm3">
          🔥 SISTEMA LOWER BODY 360° · 6 Módulos + 5 Bonos
        </motion.p>

        <motion.a href={OFFER_ANCHOR} initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.14
      }} className="mt-2 block w-full max-w-xl" data-id="element-97" data-mp="icrn2n3lyf7n">
          <img src={PACK_IMAGE} alt="SISTEMA LOWER BODY 360°: 6 módulos digitales y 5 bonos incluidos" className="mx-auto w-full rounded-xl" data-id="element-98" data-mp="161jcx7tq6lh9" />
        </motion.a>

        <div className="mt-2.5 flex w-full flex-col items-center gap-1.5" data-id="element-99" data-mp="x030yvn9ibax">
          <CtaButton size="lg" data-id="element-100" data-mp="3ltgltmwy8kmr">🚀 SÍ, QUIERO COMENZAR AHORA</CtaButton>
          <p className="flex flex-wrap items-center justify-center gap-x-2 text-[0.66rem] font-bold uppercase tracking-wide text-muted sm:text-xs" data-id="element-101" data-mp="3lqm25xlrf3ue">
            Acceso Digital Inmediato
            <span aria-hidden="true" data-id="element-102" data-mp="1xb5mo58pibbw">•</span>
            <span className="flex items-center gap-1" data-id="element-103" data-mp="21aekbl6vatcq">
              <ShieldCheckIcon size={13} className="text-gold" data-id="element-104" data-mp="218toztcqb6dt" />
              Garantía de 7 Días
            </span>
          </p>
        </div>
      </div>
    </header>;
}